/**
 * This component is used to query the API for the current content of the online banking widget.
 *
 * This React component will be handled in the snippetsInit.js,
 * which renders it to `<div id="online-banking"></div>` inside the meta navigation
 *
 */

import React from 'react';
import $ from 'jquery';

class OnlineBanking extends React.Component {
  constructor() {
    super();
    this.state = {
      htmlContent: ''
    };
  }

  componentDidMount() {
    this.fetchContent();
  }

  fetchContent() {
    $.ajax({
      url: '/api/content-snippets?identifier=online-banking',
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ htmlContent: data.snippets[0].text_content });
        }
      },
      error: (xhr, status, err) => console.error(xhr, status, err.toString())
    });
  }

  render() {
    return (
      <div
        className="online-banking snippet"
        dangerouslySetInnerHTML={{ __html: this.state.htmlContent }}
      />
    );
  }
}

export default OnlineBanking;



// WEBPACK FOOTER //
// ./components/onlineBanking.js